import {
  StudentEmployerPlacementStatus,
  StudentWorkPlacementJourneyStatus,
  journeyStatusLabel,
} from '@duke-hq/shared-constants/studentEnrolment';

type StatusMetadata = { label: string; color: string; variant: 'outline' };

export const journeyStatusMetadata = {
  AWAITING_CHECKLIST: {
    label: journeyStatusLabel.AWAITING_CHECKLIST,
    color: 'orange',
    variant: 'outline',
  },
  AWAITING_APPROVAL: {
    label: journeyStatusLabel.AWAITING_APPROVAL,
    color: 'yellow',
    variant: 'outline',
  },
  AWAITING_PLACEMENT: {
    label: journeyStatusLabel.AWAITING_PLACEMENT,
    color: 'blue',
    variant: 'outline',
  },
  INTERVIEWING: { label: journeyStatusLabel.INTERVIEWING, color: 'purple', variant: 'outline' },
  AWAITING_CONTRACT: {
    label: journeyStatusLabel.AWAITING_CONTRACT,
    color: 'cyan',
    variant: 'outline',
  },
  PLACED: { label: journeyStatusLabel.PLACED, color: 'teal', variant: 'outline' },
  COMPLETED: { label: journeyStatusLabel.COMPLETED, color: 'gray', variant: 'outline' },
} as const satisfies Record<StudentWorkPlacementJourneyStatus, StatusMetadata>;

export const employerPlacementStatusMetadata = {
  IN_PROGRESS: { label: 'In progress', color: 'teal', variant: 'outline' },
  AWAITING_EVIDENCE: { label: 'Awaiting evidence', color: 'pink', variant: 'outline' },
  COMPLETED: { label: 'Completed', color: 'gray', variant: 'outline' },
  FAILED: { label: 'Failed', color: 'red', variant: 'outline' },
  CANCELLED: { label: 'Cancelled', color: 'gray', variant: 'outline' },
} as const satisfies Record<StudentEmployerPlacementStatus, StatusMetadata>;
